let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4Lgj0"), load("kSJiq"), load("bVl1P")]).then(() => parcelRequire('hnY2b'));